/**
 * @description 사용자 관련 쿼리 키 모음
 * detail: 사용자 상세 정보 조회 키
 * teamOwners: 팀 소유자 목록 조회 키
 * userOwners: 사용자 소유자 목록 조회 키
 * domainUsers: 도메인 사용자 목록 조회 키
 * lists: 사용자 목록 조회 키 (관리자용)
 * roles: 역할 목록 조회 키
 */

export const userKeys = {
  all: ['user'] as const,

  detailPrefix: () => [...userKeys.all, 'detail'] as const,
  detail: (userName: string) => [...userKeys.detailPrefix(), userName] as const,

  teamOwnersPrefix: () => [...userKeys.all, 'teamOwners'] as const,
  teamOwners: () => [...userKeys.teamOwnersPrefix()] as const,

  userOwnersPrefix: () => [...userKeys.all, 'userOwners'] as const,
  userOwners: () => [...userKeys.userOwnersPrefix()] as const,

  domainUsersPrefix: () => [...userKeys.all, 'domainUsers'] as const,
  domainUsers: () => [...userKeys.domainUsersPrefix()] as const,

  listsPrefix: () => [...userKeys.all, 'lists'] as const,
  lists: (filters: { query?: string; page?: number; size?: number }) => [...userKeys.listsPrefix(), filters] as const,

  rolesPrefix: () => [...userKeys.all, 'roles'] as const,
  roles: () => [...userKeys.rolesPrefix()] as const,
  allRoles: () => [...userKeys.rolesPrefix(), 'all'] as const,
} as const;
